'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _CalculatorSelectableBox = require('pricing-pages-unified-ui/components/calculator/CalculatorSelectableBox');

var _CalculatorSelectableBox2 = _interopRequireDefault(_CalculatorSelectableBox);

var _partial = require('transmute/partial');

var _partial2 = _interopRequireDefault(_partial);

var _SelectionButtonWrapper = require('pricing-pages-unified-ui/components/calculator/SelectionButtonWrapper');

var _SelectionButtonWrapper2 = _interopRequireDefault(_SelectionButtonWrapper);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrentPlanText = _styledComponents2.default.span.withConfig({
  displayName: 'EditionSelectionButton__CurrentPlanText'
})(['font-weight:600;']);

var StyledFormattedMessage = (0, _styledComponents2.default)(_FormattedMessage2.default).withConfig({
  displayName: 'EditionSelectionButton__StyledFormattedMessage'
})(['&&&{font-size:13px;}']);

var ButtonContents = (0, _styledComponents2.default)(_UIFlex2.default).withConfig({
  displayName: 'EditionSelectionButton__ButtonContents'
})(['height:36px;line-height:18px;']);

var EditionSelectionButton = function EditionSelectionButton(_ref) {
  var selected = _ref.selected,
      edition = _ref.edition,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      currentPlan = _ref.currentPlan;
  return _react2.default.createElement(
    _SelectionButtonWrapper2.default,
    null,
    _react2.default.createElement(
      _CalculatorSelectableBox2.default,
      {
        onClick: (0, _partial2.default)(onClick, edition),
        selected: selected,
        disabled: disabled,
        'data-selenium-id': edition + '-edition-button'
      },
      _react2.default.createElement(
        ButtonContents,
        { direction: 'column', align: 'center', justify: 'center' },
        _react2.default.createElement(StyledFormattedMessage, {
          className: 'plan-selector-button-text',
          message: 'pricingPage.calculator.edition.' + edition
        }),
        currentPlan && _react2.default.createElement(
          CurrentPlanText,
          null,
          _react2.default.createElement(StyledFormattedMessage, { message: 'pricingPage.highlightedMerchCards.currentPlanParentheses' })
        )
      )
    )
  );
};

EditionSelectionButton.propTypes = {
  edition: _react.PropTypes.string.isRequired,
  selected: _react.PropTypes.bool.isRequired,
  disabled: _react.PropTypes.bool.isRequired,
  onClick: _react.PropTypes.func,
  currentPlan: _react.PropTypes.bool
};

EditionSelectionButton.defaultProps = {
  currentPlan: false
};

exports.default = EditionSelectionButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/EditionSelectionButton.js
// module id = 739
// module chunks = 3 4